type FlagLoader = () => Promise<{ default: import('react').ComponentType<import('react').SVGProps<SVGSVGElement>> }>

export const countryFlagGlyphNames = ['Ad', 'Ae', 'Af', 'Ag', 'Ai', 'Al', 'Am', 'Ao', 'Aq', 'Ar', 'As', 'At', 'Au', 'Aw', 'Ax', 'Az', 'Ba', 'Bb', 'Bd', 'Be', 'Bf', 'Bg', 'Bh', 'Bi', 'Bj', 'Bl', 'Bm', 'Bn', 'Bo', 'Bq', 'Br', 'Bs', 'Bt', 'Bv', 'Bw', 'By', 'Bz', 'Ca', 'Cc', 'Cd', 'Cf', 'Cg', 'Ch', 'Ci', 'Ck', 'Cl', 'Cm', 'Cn', 'Co', 'Cp', 'Cr', 'Cu', 'Cv', 'Cw', 'Cx', 'Cy', 'Cz', 'De', 'Dj', 'Dk', 'Dm', 'Do', 'Dz', 'Ec', 'Ee', 'Eg', 'Eh', 'Er', 'Es', 'Et', 'Fi', 'Fj', 'Fk', 'Fm', 'Fo', 'Fr', 'Ga', 'Gb', 'Gd', 'Ge', 'Gf', 'Gg', 'Gh', 'Gi', 'Gl', 'Gm', 'Gn', 'Gp', 'Gq', 'Gr', 'Gs', 'Gt', 'Gu', 'Gw', 'Gy', 'Hk', 'Hm', 'Hn', 'Hr', 'Ht', 'Hu', 'Id', 'Ie', 'Il', 'Im', 'In', 'Io', 'Iq', 'Ir', 'Is', 'It', 'Je', 'Jm', 'Jo', 'Jp', 'Ke', 'Kg', 'Kh', 'Ki', 'Km', 'Kn', 'Kp', 'Kr', 'Kw', 'Ky', 'Kz', 'La', 'Lb', 'Lc', 'Li', 'Lk', 'Lr', 'Ls', 'Lt', 'Lu', 'Lv', 'Ly', 'Ma', 'Mc', 'Md', 'Me', 'Mf', 'Mg', 'Mh', 'Mk', 'Ml', 'Mm', 'Mn', 'Mo', 'Mp', 'Mq', 'Mr', 'Ms', 'Mt', 'Mu', 'Mv', 'Mw', 'Mx', 'My', 'Mz', 'Na', 'Nc', 'Ne', 'Nf', 'Ng', 'Ni', 'Nl', 'No', 'Np', 'Nr', 'Nu', 'Nz', 'Om', 'Pa', 'Pe', 'Pf', 'Pg', 'Ph', 'Pk', 'Pl', 'Pm', 'Pn', 'Pr', 'Ps', 'Pt', 'Pw', 'Py', 'Qa', 'Re', 'Ro', 'Rs', 'Ru', 'Rw', 'Sa', 'Sb', 'Sc', 'Sd', 'Se', 'Sg', 'Sh', 'Si', 'Sj', 'Sk', 'Sl', 'Sm', 'Sn', 'So', 'Sr', 'Ss', 'St', 'Sv', 'Sx', 'Sy', 'Sz', 'Tc', 'Td', 'Tf', 'Tg', 'Th', 'Tj', 'Tk', 'Tl', 'Tm', 'Tn', 'To', 'Tr', 'Tt', 'Tv', 'Tw', 'Tz', 'Ua', 'Ug', 'Um', 'Us', 'Uy', 'Uz', 'Va', 'Vc', 'Ve', 'Vg', 'Vi', 'Vn', 'Vu', 'Wf', 'Ws', 'Ye', 'Yt', 'Za', 'Zm', 'Zw'] as const

export type CountryFlagGlyphName = (typeof countryFlagGlyphNames)[number]

export const lazyGlyphLoaders: { [key: string]: FlagLoader | undefined } = {
  Ad: () => import('./Ad'),
  Ae: () => import('./Ae'),
  Af: () => import('./Af'),
  Ag: () => import('./Ag'),
  Ai: () => import('./Ai'),
  Al: () => import('./Al'),
  Am: () => import('./Am'),
  Ao: () => import('./Ao'),
  Aq: () => import('./Aq'),
  Ar: () => import('./Ar'),
  As: () => import('./As'),
  At: () => import('./At'),
  Au: () => import('./Au'),
  Aw: () => import('./Aw'),
  Ax: () => import('./Ax'),
  Az: () => import('./Az'),
  Ba: () => import('./Ba'),
  Bb: () => import('./Bb'),
  Bd: () => import('./Bd'),
  Be: () => import('./Be'),
  Bf: () => import('./Bf'),
  Bg: () => import('./Bg'),
  Bh: () => import('./Bh'),
  Bi: () => import('./Bi'),
  Bj: () => import('./Bj'),
  Bl: () => import('./Bl'),
  Bm: () => import('./Bm'),
  Bn: () => import('./Bn'),
  Bo: () => import('./Bo'),
  Bq: () => import('./Bq'),
  Br: () => import('./Br'),
  Bs: () => import('./Bs'),
  Bt: () => import('./Bt'),
  Bv: () => import('./Bv'),
  Bw: () => import('./Bw'),
  By: () => import('./By'),
  Bz: () => import('./Bz'),
  Ca: () => import('./Ca'),
  Cc: () => import('./Cc'),
  Cd: () => import('./Cd'),
  Cf: () => import('./Cf'),
  Cg: () => import('./Cg'),
  Ch: () => import('./Ch'),
  Ci: () => import('./Ci'),
  Ck: () => import('./Ck'),
  Cl: () => import('./Cl'),
  Cm: () => import('./Cm'),
  Cn: () => import('./Cn'),
  Co: () => import('./Co'),
  Cp: () => import('./Cp'),
  Cr: () => import('./Cr'),
  Cu: () => import('./Cu'),
  Cv: () => import('./Cv'),
  Cw: () => import('./Cw'),
  Cx: () => import('./Cx'),
  Cy: () => import('./Cy'),
  Cz: () => import('./Cz'),
  De: () => import('./De'),
  Dj: () => import('./Dj'),
  Dk: () => import('./Dk'),
  Dm: () => import('./Dm'),
  Do: () => import('./Do'),
  Dz: () => import('./Dz'),
  Ec: () => import('./Ec'),
  Ee: () => import('./Ee'),
  Eg: () => import('./Eg'),
  Eh: () => import('./Eh'),
  Er: () => import('./Er'),
  Es: () => import('./Es'),
  Et: () => import('./Et'),
  Fi: () => import('./Fi'),
  Fj: () => import('./Fj'),
  Fk: () => import('./Fk'),
  Fm: () => import('./Fm'),
  Fo: () => import('./Fo'),
  Fr: () => import('./Fr'),
  Ga: () => import('./Ga'),
  Gb: () => import('./Gb'),
  Gd: () => import('./Gd'),
  Ge: () => import('./Ge'),
  Gf: () => import('./Gf'),
  Gg: () => import('./Gg'),
  Gh: () => import('./Gh'),
  Gi: () => import('./Gi'),
  Gl: () => import('./Gl'),
  Gm: () => import('./Gm'),
  Gn: () => import('./Gn'),
  Gp: () => import('./Gp'),
  Gq: () => import('./Gq'),
  Gr: () => import('./Gr'),
  Gs: () => import('./Gs'),
  Gt: () => import('./Gt'),
  Gu: () => import('./Gu'),
  Gw: () => import('./Gw'),
  Gy: () => import('./Gy'),
  Hk: () => import('./Hk'),
  Hm: () => import('./Hm'),
  Hn: () => import('./Hn'),
  Hr: () => import('./Hr'),
  Ht: () => import('./Ht'),
  Hu: () => import('./Hu'),
  Id: () => import('./Id'),
  Ie: () => import('./Ie'),
  Il: () => import('./Il'),
  Im: () => import('./Im'),
  In: () => import('./In'),
  Io: () => import('./Io'),
  Iq: () => import('./Iq'),
  Ir: () => import('./Ir'),
  Is: () => import('./Is'),
  It: () => import('./It'),
  Je: () => import('./Je'),
  Jm: () => import('./Jm'),
  Jo: () => import('./Jo'),
  Jp: () => import('./Jp'),
  Ke: () => import('./Ke'),
  Kg: () => import('./Kg'),
  Kh: () => import('./Kh'),
  Ki: () => import('./Ki'),
  Km: () => import('./Km'),
  Kn: () => import('./Kn'),
  Kp: () => import('./Kp'),
  Kr: () => import('./Kr'),
  Kw: () => import('./Kw'),
  Ky: () => import('./Ky'),
  Kz: () => import('./Kz'),
  La: () => import('./La'),
  Lb: () => import('./Lb'),
  Lc: () => import('./Lc'),
  Li: () => import('./Li'),
  Lk: () => import('./Lk'),
  Lr: () => import('./Lr'),
  Ls: () => import('./Ls'),
  Lt: () => import('./Lt'),
  Lu: () => import('./Lu'),
  Lv: () => import('./Lv'),
  Ly: () => import('./Ly'),
  Ma: () => import('./Ma'),
  Mc: () => import('./Mc'),
  Md: () => import('./Md'),
  Me: () => import('./Me'),
  Mf: () => import('./Mf'),
  Mg: () => import('./Mg'),
  Mh: () => import('./Mh'),
  Mk: () => import('./Mk'),
  Ml: () => import('./Ml'),
  Mm: () => import('./Mm'),
  Mn: () => import('./Mn'),
  Mo: () => import('./Mo'),
  Mp: () => import('./Mp'),
  Mq: () => import('./Mq'),
  Mr: () => import('./Mr'),
  Ms: () => import('./Ms'),
  Mt: () => import('./Mt'),
  Mu: () => import('./Mu'),
  Mv: () => import('./Mv'),
  Mw: () => import('./Mw'),
  Mx: () => import('./Mx'),
  My: () => import('./My'),
  Mz: () => import('./Mz'),
  Na: () => import('./Na'),
  Nc: () => import('./Nc'),
  Ne: () => import('./Ne'),
  Nf: () => import('./Nf'),
  Ng: () => import('./Ng'),
  Ni: () => import('./Ni'),
  Nl: () => import('./Nl'),
  No: () => import('./No'),
  Np: () => import('./Np'),
  Nr: () => import('./Nr'),
  Nu: () => import('./Nu'),
  Nz: () => import('./Nz'),
  Om: () => import('./Om'),
  Pa: () => import('./Pa'),
  Pe: () => import('./Pe'),
  Pf: () => import('./Pf'),
  Pg: () => import('./Pg'),
  Ph: () => import('./Ph'),
  Pk: () => import('./Pk'),
  Pl: () => import('./Pl'),
  Pm: () => import('./Pm'),
  Pn: () => import('./Pn'),
  Pr: () => import('./Pr'),
  Ps: () => import('./Ps'),
  Pt: () => import('./Pt'),
  Pw: () => import('./Pw'),
  Py: () => import('./Py'),
  Qa: () => import('./Qa'),
  Re: () => import('./Re'),
  Ro: () => import('./Ro'),
  Rs: () => import('./Rs'),
  Ru: () => import('./Ru'),
  Rw: () => import('./Rw'),
  Sa: () => import('./Sa'),
  Sb: () => import('./Sb'),
  Sc: () => import('./Sc'),
  Sd: () => import('./Sd'),
  Se: () => import('./Se'),
  Sg: () => import('./Sg'),
  Sh: () => import('./Sh'),
  Si: () => import('./Si'),
  Sj: () => import('./Sj'),
  Sk: () => import('./Sk'),
  Sl: () => import('./Sl'),
  Sm: () => import('./Sm'),
  Sn: () => import('./Sn'),
  So: () => import('./So'),
  Sr: () => import('./Sr'),
  Ss: () => import('./Ss'),
  St: () => import('./St'),
  Sv: () => import('./Sv'),
  Sx: () => import('./Sx'),
  Sy: () => import('./Sy'),
  Sz: () => import('./Sz'),
  Tc: () => import('./Tc'),
  Td: () => import('./Td'),
  Tf: () => import('./Tf'),
  Tg: () => import('./Tg'),
  Th: () => import('./Th'),
  Tj: () => import('./Tj'),
  Tk: () => import('./Tk'),
  Tl: () => import('./Tl'),
  Tm: () => import('./Tm'),
  Tn: () => import('./Tn'),
  To: () => import('./To'),
  Tr: () => import('./Tr'),
  Tt: () => import('./Tt'),
  Tv: () => import('./Tv'),
  Tw: () => import('./Tw'),
  Tz: () => import('./Tz'),
  Ua: () => import('./Ua'),
  Ug: () => import('./Ug'),
  Um: () => import('./Um'),
  Us: () => import('./Us'),
  Uy: () => import('./Uy'),
  Uz: () => import('./Uz'),
  Va: () => import('./Va'),
  Vc: () => import('./Vc'),
  Ve: () => import('./Ve'),
  Vg: () => import('./Vg'),
  Vi: () => import('./Vi'),
  Vn: () => import('./Vn'),
  Vu: () => import('./Vu'),
  Wf: () => import('./Wf'),
  Ws: () => import('./Ws'),
  Ye: () => import('./Ye'),
  Yt: () => import('./Yt'),
  Za: () => import('./Za'),
  Zm: () => import('./Zm'),
  Zw: () => import('./Zw'),
}
